import { API_ROUTES } from '../types/api.routes';
import { ROUTES } from '../types/routes';
import { v4 as uuidv4 } from 'uuid';
import { customFetch } from '../utils';
import { TSubmitVerificationBody } from '../types/types';

export async function fetchSumSubInfo() {
	const wState = new URLSearchParams(window.location.search).get(
		'wstate'
	) as string;

	const sumsubInfoData = await customFetch(
		API_ROUTES.REGISTRATION.SUMSUB_INFO.URL +
			'?' +
			new URLSearchParams({
				wstate: wState
			}),
		{
			method: API_ROUTES.REGISTRATION.SUMSUB_INFO.METHOD,
			headers: {
				f2x_request_id: uuidv4(),
				'Content-Type': 'application/json'
			}
		}
	);

	const jsonSumsubInfoData = await sumsubInfoData.json();

	if (sumsubInfoData.status != 200) {
		if (sumsubInfoData.status === 503) {
			const locale =
				window.location.pathname.split('/')[1] != 'en' ? 'ru' : 'en';
			window.location.replace(
				ROUTES.REGISTRATION.MAINTAIN.replace(':locale', locale)
			);
		}
		throw jsonSumsubInfoData;
	}

	sessionStorage.setItem('sumsubInfo', JSON.stringify(jsonSumsubInfoData));

	return jsonSumsubInfoData;
}

export async function fetchVerificationSubmit(data: TSubmitVerificationBody) {
	const verificationData = await customFetch(
		API_ROUTES.REGISTRATION.PROFILE.URL,
		{
			method: API_ROUTES.REGISTRATION.PROFILE.METHOD,
			headers: {
				f2x_request_id: uuidv4(),
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				wstate: data.wState,
				firstName: data.firstName,
				middleName: data.middleName,
				lastName: data.lastName,
				dateOfBirth: data.dateOfBirth.replaceAll('.', ''),
				citizenship: data.citizenship
			})
		}
	);

	const verificationDataJson = await verificationData.json();
	if (verificationData.status != 200) {
		if (verificationData.status === 503) {
			const locale =
				window.location.pathname.split('/')[1] != 'en' ? 'ru' : 'en';
			window.location.replace(
				ROUTES.REGISTRATION.MAINTAIN.replace(':locale', locale)
			);
		}
		throw verificationDataJson;
	}

	return verificationDataJson;
}
